const BUILD_RELOAD_KEY = "mbid.reloadedForBuildId";
const ASSET_RELOAD_KEY = "mbid.assetReloadAt";
const ASSET_RELOAD_COOLDOWN_MS = 15000;

let requestedBuildId = null;

function readOptions(options) {
  if (!options || typeof options !== "object") return {};
  if (typeof options.preventDefault === "function") return {};
  return options;
}

function runtime() {
  return {
    storage: window.sessionStorage,
    href: window.location.href,
    replace: (url) => window.location.replace(url),
    clearCacheStorage: () => {
      if (!("caches" in window)) return;
      window.caches
        .keys()
        .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))));
    },
  };
}

export function shouldAutoReload(buildId, storage) {
  if (!buildId) return true;
  return storage.getItem(BUILD_RELOAD_KEY) !== String(buildId);
}

export function isReloadInProgress(buildId) {
  return Boolean(buildId) && requestedBuildId === String(buildId);
}

export function hardReloadClient(options, deps) {
  const { buildId, force } = readOptions(options);
  const env = deps || runtime();
  if (buildId && !force && !shouldAutoReload(buildId, env.storage)) {
    return false;
  }
  if (buildId) {
    env.storage.setItem(BUILD_RELOAD_KEY, String(buildId));
    requestedBuildId = String(buildId);
  }
  if (!deps && env.clearCacheStorage) env.clearCacheStorage();

  const url = new URL(env.href);
  url.searchParams.set("_v", Date.now().toString());
  env.replace(url.toString());
  return true;
}

export function reloadForMissingAsset(deps) {
  const env = deps || runtime();
  const now = env.now || Date.now();
  const last = Number(env.storage.getItem(ASSET_RELOAD_KEY) || 0);
  if (last && now - last < ASSET_RELOAD_COOLDOWN_MS) return false;
  env.storage.setItem(ASSET_RELOAD_KEY, String(now));
  return hardReloadClient({ force: true }, env);
}

export function stripReloadQuery(deps) {
  const env = deps || {
    href: window.location.href,
    replaceState: (state, url) => window.history.replaceState(state, "", url),
    state: window.history.state,
  };
  const url = new URL(env.href);
  if (!url.searchParams.has("_v")) return false;
  url.searchParams.delete("_v");
  const next = `${url.pathname}${url.search}${url.hash}`;
  env.replaceState(env.state, next);
  return true;
}

export function isMissingAssetError(message) {
  return /ChunkLoadError|Loading chunk|Loading CSS chunk|CSS_CHUNK_LOAD_FAILED|Failed to fetch dynamically imported module/.test(
    message || ""
  );
}
